import * as React from 'react';
import { getPadding } from '../views/common/utils';
import { getBorders } from '../views/common/utils';
/** @hidden */
export var useCellSync = function (args, inputs) {
    var element = args.element;
    var syncWidth = function () {
        if (!element || !element.current) {
            return;
        }
        var widest = [];
        var biggestPadding = [];
        var biggestBorder = [];
        var elements = element.current.querySelectorAll(args.selector);
        elements.forEach(function (el) {
            var width = el.getBoundingClientRect().width;
            var level = args.explicitDepth && args.attribute !== undefined ? el.getAttribute(args.attribute) : 0;
            var padding = getPadding(el, true);
            var border = getBorders(el, true);
            if (level === null) {
                return;
            }
            if (!biggestBorder[level] || border > biggestBorder[level]) {
                biggestBorder[level] = border;
            }
            if (!biggestPadding[level] || padding > biggestPadding[level]) {
                biggestPadding[level] = padding;
            }
            if (!widest[level] || width > widest[level]) {
                widest[level] = width;
            }
        });
        elements.forEach(function (el) {
            var level = args.explicitDepth ? el.getAttribute(args.attribute) : 0;
            if (level === null) {
                return;
            }
            el.style.minWidth = widest[level] - biggestPadding[level] - biggestBorder[level] + "px";
        });
    };
    React.useLayoutEffect(syncWidth, inputs);
};
//# sourceMappingURL=useCellSync.js.map